import styled from '@emotion/styled';
import COLORS3, { COLORS_SEMANTIC } from '../../styles/emotion/colors3';
import FONT from '../../styles/emotion/fonts';
import MEDIA_QUERY_V2 from '../../styles/emotion/mediaQueryV2';
import SPACING from '../../styles/emotion/spacing';

/** Layout (and border) component for the DGC Upsell */
export const DGCsUpsellContainer = styled.div<{ isVisible: boolean; isUnderTest: boolean }>`
  align-items: center;
  border-radius: 16px;
  border: 1px dashed ${COLORS3.BLACK_030};
  ${(props) =>
    props.isUnderTest &&
    `
    border: none;
    background-color: ${COLORS3.BLACK_005};
  `};
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: ${SPACING.S16};

  ${(props) =>
    !props.isVisible &&
    `
    display: none;
  `}

  ${MEDIA_QUERY_V2.MOBILE} {
    flex-direction: column;
    gap: 12px;

    ${(props) =>
      !props.isUnderTest &&
      `
      button {
        width: 100%;
      }
    `};
  }
`;

/**
 * Wraps the image and copy in a flex div with a gap
 */
export const DGCInfo = styled.div<{ isUnderTest: boolean }>`
  align-items: center;
  display: flex;
  gap: ${SPACING.S24};
  ${(props) =>
    props.isUnderTest &&
    `
    flex-grow: 1;
    justify-content: space-between;
  `};

  ${MEDIA_QUERY_V2.MOBILE} {
    ${(props) =>
      !props.isUnderTest &&
      `
      align-items: flex-start;
    `};
    justify-content: flex-start;
  }
`;

/** Sizes and rotates the DGC image  */
export const DGCImageWithRotation = styled.img`
  width: 80px;
  transform: rotate(-8deg);
`;

/** Layout component for the text in the DGC Upsell */
export const DGCCopyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;

  ${MEDIA_QUERY_V2.MOBILE} {
    gap: 4px;
    margin-bottom: 8px;
  }
`;

/** Wrapper for text, emjoi and price */
export const DGCHed = styled.p`
  color: ${COLORS3.BLACK_100};
  font-size: ${FONT.FONT_SIZE_SMALLER};
  line-height: 24px;
  margin: 0;
  ${MEDIA_QUERY_V2.MOBILE} {
    line-height: 20px;
  }
`;

/** Envelope emoji */
export const EnvelopeIconContainer = styled.span`
  margin: 0 ${SPACING.S4} !important;
`;

/** Renders text as bold */
export const Bold = styled.span`
  font-weight: ${FONT.WEIGHT.BOLD};
`;

/** Copy DEK for the DGC Upsell */
export const DGCDek = styled.p`
  color: ${COLORS3.BLACK_050};
  font-size: ${FONT.FONT_SIZE_SMALLER};
  line-height: 20px;
  margin: 0;
`;

export const AddToCartContainer = styled.div`
  font-size: ${FONT.FONT_SIZE_SMALLER};
  min-width: 89px;
  ${MEDIA_QUERY_V2.EXCLUDE_MOBILE} {
    display: flex;
    gap: ${SPACING.S16};
    align-items: center;
  }
`;

export const AddedToCart = styled.div`
  display: flex;
  gap: ${SPACING.S4};
  color: ${COLORS_SEMANTIC.POSITIVE_100};
  justify-content: right;
`;
